var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "templates-gallery", class: { embedded: _vm.embedded } },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          !_vm.embedded
            ? _c("h3", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("tables.templates.sidebarTitle"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("a-input-search", {
            staticClass: "search-input",
            staticStyle: { width: "280px" },
            attrs: {
              placeholder: _vm.$t("tables.templates.searchPlaceholder"),
            },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "a-spin",
            {
              attrs: {
                spinning: _vm.loading,
                wrapperClassName: "content-spin",
              },
            },
            [
              _c(
                "div",
                { staticClass: "sector-tabs" },
                _vm._l(_vm.availableSectors, function (sector) {
                  return _c(
                    "button",
                    {
                      key: sector.key,
                      staticClass: "sector-tab",
                      class: { active: _vm.activeSector === sector.key },
                      on: {
                        click: function ($event) {
                          _vm.activeSector = sector.key
                        },
                      },
                    },
                    [
                      sector.icon
                        ? _c("i", { staticClass: "material-icons" }, [
                            _vm._v(_vm._s(sector.icon)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(sector.label))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "count" }, [
                        _vm._v("(" + _vm._s(sector.count) + ")"),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.filteredTemplates.length === 0
                ? _c("div", { staticClass: "empty-state" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("search_off"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.searchText
                            ? _vm.$t("tables.templates.noResults")
                            : _vm.$t("tables.templates.noTemplatesInSector")
                        )
                      ),
                    ]),
                  ])
                : _c(
                    "div",
                    { staticClass: "template-list" },
                    _vm._l(_vm.filteredTemplates, function (tpl) {
                      return _c(
                        "div",
                        {
                          key: tpl.key,
                          staticClass: "template-list-item",
                          on: {
                            click: function ($event) {
                              return _vm.openPreview(tpl)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "template-list-item-inner-wrapper" },
                            [
                              _c("div", { staticClass: "block-template" }, [
                                _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "icon-tile",
                                      style: _vm.iconTileStyle(tpl.sector),
                                    },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass: "material-icons",
                                          style: {
                                            color: _vm.iconColor(tpl.sector),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              tpl.icon || "dashboard_customize"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(tpl.name)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "short-description" },
                                    [_vm._v(_vm._s(tpl.description))]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "card-meta" }, [
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              content: _vm.$t(
                                                "tables.templates.tableCountTooltip",
                                                { count: tpl.tables.length }
                                              ),
                                            },
                                            expression:
                                              "{ content: $t('tables.templates.tableCountTooltip', { count: tpl.tables.length }) }",
                                          },
                                        ],
                                        staticClass: "meta-chip",
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("table_chart")]
                                        ),
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(tpl.tables.length) +
                                            " " +
                                            _vm._s(
                                              _vm.$t(
                                                "tables.templates.tablesCountSuffix"
                                              )
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    tpl.relations.length > 0
                                      ? _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  content: _vm.$t(
                                                    "tables.templates.relationsCountTooltip",
                                                    {
                                                      count:
                                                        tpl.relations.length,
                                                    }
                                                  ),
                                                },
                                                expression:
                                                  "{ content: $t('tables.templates.relationsCountTooltip', { count: tpl.relations.length }) }",
                                              },
                                            ],
                                            staticClass: "meta-chip",
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("hub")]
                                            ),
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(tpl.relations.length) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "tables.templates.relationsCountSuffix"
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    tpl.hasDemoData
                                      ? _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  content: _vm.$t(
                                                    "tables.templates.demoDataTooltip"
                                                  ),
                                                },
                                                expression:
                                                  "{ content: $t('tables.templates.demoDataTooltip') }",
                                              },
                                            ],
                                            staticClass: "meta-chip demo",
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("science")]
                                            ),
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "tables.templates.demoDataChip"
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "card-action" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: { type: "primary", ghost: "" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.openPreview(tpl)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "tables.templates.useTemplate"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.previewVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                xlarge: "",
                showFooter: false,
                title: _vm.selectedTemplate
                  ? _vm.selectedTemplate.name
                  : _vm.$t("tables.templates.previewTitle"),
              },
              on: { cancel: _vm.closePreview },
            },
            [
              _vm.selectedTemplate
                ? _c("TemplatePreview", {
                    attrs: { templateKey: _vm.selectedTemplate.key },
                    on: { applied: _vm.onApplied, cancel: _vm.closePreview },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }